import { useLocalization } from '@shared-ui/localization-context';
import * as React from 'react';
import { UitkOverlayButton, UitkButtonSize } from 'uitk-react-button';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkLayoutPosition } from 'uitk-react-layout-position';
import { UitkScrim, UitkScrimType } from 'uitk-react-scrim';
import { classNames } from 'uitk-react-utils';
import { PlayerState } from './types.esm.js';
import styles from './uitk-video.css';
var getClassNameList = classNames.bind(styles);
var UitkVideoLayerControls = function (_a) {
  var className = _a.className,
    controls = _a.controls,
    playerState = _a.playerState,
    buttonText = _a.buttonText;
  var l10n = useLocalization();
  var playPauseControls = function () {
    return playerState === PlayerState.PLAYING ? controls.pause : controls.play;
  };
  var playPauseText = function () {
    var _a, _b;
    if (playerState === PlayerState.PLAYING) {
      return (_a = buttonText === null || buttonText === void 0 ? void 0 : buttonText.pauseButton) !== null && _a !== void 0 ? _a : l10n.formatText('video.pauseButton.label');
    }
    return (_b = buttonText === null || buttonText === void 0 ? void 0 : buttonText.playButton) !== null && _b !== void 0 ? _b : l10n.formatText('video.playButton.label');
  };
  var shouldHideControls = [PlayerState.BUFFERING, PlayerState.PLAYING, PlayerState.PAUSED, PlayerState.UNSTARTED].includes(playerState);
  return React.createElement("div", {
    className: getClassNameList(className)
  }, playerState === PlayerState.UNSTARTED ? React.createElement(UitkScrim, {
    type: UitkScrimType.OVERLAY
  }) : null, React.createElement("button", {
    type: "button",
    "aria-label": playPauseText(),
    className: getClassNameList('uitk-video-layer-controls-link', {
      'uitk-video-hide-controls': shouldHideControls
    }),
    onClick: playPauseControls()
  }, React.createElement("span", {
    className: getClassNameList('uitk-video-hide-controls')
  }, playPauseText())), React.createElement(UitkLayoutPosition, {
    type: "absolute",
    position: {
      top: 'center',
      left: 'center'
    },
    className: getClassNameList('uitk-video-play-button-wrapper')
  }, React.createElement(UitkOverlayButton, {
    "aria-hidden": "true",
    tabIndex: -1,
    onClick: playPauseControls(),
    size: UitkButtonSize.LARGE,
    className: getClassNameList({
      'uitk-video-hide-controls': shouldHideControls
    })
  }, React.createElement(UitkIcon, {
    id: "play",
    name: "play_arrow",
    size: UitkIconSize.LARGE,
    title: playPauseText()
  }))));
};
export { UitkVideoLayerControls };